var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{style:({ 'line-height': '1.5em' })},[_vm._v(" "+_vm._s(_vm.modalDetail.simpleBody)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }